// extracted by mini-css-extract-plugin
export default {"message":"message---VXD4l","message__content":"message__content---Eg68p","error":"error---V1Fpt","stack":"stack---G7VVk"};